import Vue from 'vue'
import LottiePlayer from '@dotlottie/player-component'

Vue.component('DotlottiePlayer', LottiePlayer)
